/**
 * Top Navigation JavaScript
 * Handles mobile hamburger menu functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    const hamburgerBtn = document.querySelector('[data-nav-toggle]');
    const mobileMenu = document.querySelector('[data-nav-mobile]');

    // Function to open mobile menu
    function openMobileMenu() {
        if (hamburgerBtn && mobileMenu) {
            hamburgerBtn.setAttribute('aria-expanded', 'true');
            mobileMenu.classList.remove('hidden');
            mobileMenu.classList.add('block');
        }
    }

    // Function to close mobile menu
    function closeMobileMenuFunc() {
        if (hamburgerBtn && mobileMenu) {
            hamburgerBtn.setAttribute('aria-expanded', 'false');
            mobileMenu.classList.remove('block');
            mobileMenu.classList.add('hidden');
        }
    }

    // Event listeners
    if (hamburgerBtn) {
        hamburgerBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const isExpanded = hamburgerBtn.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                closeMobileMenuFunc();
            } else {
                openMobileMenu();
            }
        });
    }

    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            const isExpanded = hamburgerBtn?.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                closeMobileMenuFunc();
            }
        }
    });

    // Handle window resize
    window.addEventListener('resize', function() {
        if (window.innerWidth >= 768) { // md breakpoint
            closeMobileMenuFunc();
        }
    });

    // Close menu when clicking on a mobile menu link
    const mobileMenuLinks = mobileMenu?.querySelectorAll('a');
    if (mobileMenuLinks) {
        mobileMenuLinks.forEach(link => {
            link.addEventListener('click', function() {
                // Small delay to allow the link to be processed
                setTimeout(() => {
                    closeMobileMenuFunc();
                }, 100);
            });
        });
    }

    // Add scroll effect to navigation
    const stickyNav = document.querySelector('.site-header');
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || window.scrollY || 0;

    window.addEventListener('scroll', function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.scrollY || 0;

        if (stickyNav) {
            // Add shadow on scroll
            if (scrollTop > 10) {
                stickyNav.classList.add('shadow-md');
            } else {
                stickyNav.classList.remove('shadow-md');
            }

            // Hide/show navigation on scroll
            // Don't trigger hide if mobile menu is open
            const isMenuOpen = hamburgerBtn && hamburgerBtn.getAttribute('aria-expanded') === 'true';

            if (!isMenuOpen) {
                if (scrollTop <= 0) {
                    // At the top
                    stickyNav.classList.remove('-translate-y-full');
                    stickyNav.classList.add('translate-y-0');
                } else if (scrollTop > lastScrollTop && scrollTop > 100) {
                    // Scrolling down - hide
                    stickyNav.classList.add('-translate-y-full');
                    stickyNav.classList.remove('translate-y-0');
                } else if (scrollTop < lastScrollTop) {
                    // Scrolling up - show
                    stickyNav.classList.remove('-translate-y-full');
                    stickyNav.classList.add('translate-y-0');
                }
            }
        }
        lastScrollTop = scrollTop;
    }, { passive: true });
});